import React, { Component } from 'react';
import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';

const plugins = { dvr: validatorjs };
// const fields = [
//   {name: "tcFileId", rules: ''},
//   {name: "title", label: "Title", rules: 'required'},
//   {name: "subscriberName", label: "Brokerage", rules: 'required'},
//   {name: "propertyAddress", label: "Property Address", rules: 'required'},
//   {name: "typeOfSale", label: "Type Of Sale", rules: 'required', type: "select"},
//   {name: "status", label: "Status ", rules: 'required'},
//   {name: "origin", label: "Origin", rules: 'required'},
//   {name: "fileSubmissionDate", label: "File Submission Date", rules: ''},
//   {name: "estimatedCloseDate", label: "Estimated Close Date", rules: ''},
//   {name: "actualCloseDate", label: "Actual Close Date", rules: ''},
//   {name: "daysInEscrow", label: "Days In Escrow", rules: ''},
//   {name: "survey", label: "Survey", rules: '', type: "checkbox", bindings: "ReactCheckbox"},
//   {name: "hud", label: "HUD", rules: '', type: "checkbox", bindings: "ReactCheckbox"},
//   {name: "thumbDrive", label: "Thumb Drive", rules: '', type: "checkbox", bindings: "ReactCheckbox"},
//   {name: "coordinatorId", label: "", rules: 'required', type: "select"},
//   {name: "coordinator", label: "", rules: ''},
//   {name: "notes", label: "Agent Email", rules: '', type: "textarea"},
//   {name: "checkStatus", label: "Check Status", rules: ''},
//   {name: "checkAmount", label: "Check Amount", rules: ''},
//   {name: "checkNumber", label: "Check Number", rules: ''},
//   {name: "depositDate", label: "Deposit Date", rules: ''}
// ]

const fields = [
    'tcFileId',
    'title',
    'subscriberName',
    'propertyAddress',
    'typeOfSale',
    'status',
    'origin',
    'fileSubmissionDate',
    'estimatedCloseDate',
    'actualCloseDate',
    'daysInEscrow',
    'survey',
    'hud',
    'thumbDrive',
    'coordinatorId',
    'coordinator',
    'notes',
    'checkStatus',
    'checkAmount',
    'checkNumber',
    'depositDate',
    'agents',
    'agents[].name',
    'agents[].email',
    'agents[].agentId',
    'agents[].preferredEmail',
    'originId',
    'subscriberId',
    'transactionId',
    'address1',
    'address2',
    'city',
    'state',
    'county',
    'zip',
    'direction',
    'unitNum',
    'expirationDate',
    'propertyType'
];
const labels = {
    tcFileId: '',
    title: 'Title',
    subscriberName: 'Brokerage',
    propertyAddress: 'Property Address',
    typeOfSale: 'Type Of Sale',
    status: 'Status',
    origin: 'Origin',
    fileSubmissionDate: 'Acceptance Date',
    estimatedCloseDate: 'Estimated Close Date',
    actualCloseDate: 'Actual Close Date',
    daysInEscrow: 'Days In Escrow',
    survey: 'Survey',
    hud: 'HUD',
    thumbDrive: 'Thumb Drive',
    coordinatorId: 'Coordinator',
    coordinator: '',
    notes: 'Notes',
    checkStatus: 'Check Status',
    checkAmount: 'Check Amount',
    checkNumber: 'Check Number',
    depositDate: 'Deposit Date',
    agents: 'Agents',
    'agents[].agentId': '',
    'agents[].name': 'Agent Name',
    'agents[].email': 'Agent SkySlope Email',
    'agents[].agentProfile': 'Agent Profile',
    'agents[].agentProfile.preferredEmail': 'Agent Preferred Email',
    originId: '',
    subscriberId: '',
    transactionId: '',
    expirationDate:'Expiration Date',
    propertyType: 'Type Of Property',
};
const bindings = {
    survey: 'ReactCheckbox',
    hud: 'ReactCheckbox',
    thumbDrive: 'ReactCheckbox',
};
const types = {
    survey: 'checkbox',
    hud: 'checkbox',
    thumbDrive: 'checkbox',
    typeOfSale: 'select',
    propertyType: 'select',
};
const rules = {
    propertyAddress: 'required',
    typeOfSale: 'required',
    status: 'required',
    origin: 'required',
    coordinatorId: 'required',
    propertyType: 'required',
};
const extra = {
    estimatedCloseDate: 'date',
    fileSubmissionDate: 'date',
    actualCloseDate: 'date',
    depositDate: 'date',
    expirationDate: 'date',
};
const disabled = {
    origin: true,
    'agents[].name': true,
    'agents[].email': true,
    'agents[].agentProfile.preferredEmail': true,
};

const limitedEdit = {
    title: true,
    subscriberName: true,
    propertyAddress: false,
    status: false,
    fileSubmissionDate: true,
    estimatedCloseDate: false,
    actualCloseDate: true,
    daysInEscrow: true,
    survey: true,
    hud: true,
    thumbDrive: true,
    coordinatorId: true,
    checkStatus: true,
    checkAmount: true,
    checkNumber: true,
    depositDate: true,
    'agents[].name': true,
    'agents[].email': true,
    expirationDate: false,
};

class FileFormMobx extends MobxReactForm {
    bindings() {
        return {
            // we can choose a name as key
            ReactCheckbox: {
                id: 'id',
                name: 'name',
                type: 'type',
                value: 'checked',
                disabled: 'disabled',
                onChange: 'onChange',
            },
        };
    }

    // onSuccess( form ) {
    // 	alert( 'Form is valid! Send the request here.' );
    // 	// get field values
    // 	console.log( 'Form Values!', form.values() );
    // }
    //
    // onError( form ) {
    // 	// get all form errors
    // 	console.log( 'All form errors', form.errors() );
    // 	// invalidate the form with a custom error message
    // 	form.invalidate( 'This is a generic error message!' );
    // }
}

// class FileFormTextInput extends Component {
// 	render() {
// 		let fieldName = this.props.fieldName
// 		let form = this.props.form
// 		return (
// 			<div className="form-group">
// 				<label htmlFor={form.$("propertyAddress" ).id}>
// 					{form.$("propertyAddress" ).label}
// 				</label>
// 				<input className="form-control" {...form.$("propertyAddress" ).bind()} />
// 				<p>{form.$("propertyAddress" ).error}</p>
// 			</div>
// 		)
// 	}
// }

export default function(role) {
    if (role && role === 'tc') {
        let disabledProperties = _.assign(disabled, limitedEdit);

        return new FileFormMobx(
            {
                fields,
                rules,
                bindings,
                labels,
                types,
                disabled: disabledProperties,
                extra,
            },
            { plugins }
        );
    } else {
        return new FileFormMobx({ fields, rules, bindings, labels, types, disabled, extra }, { plugins });
    }
}



// WEBPACK FOOTER //
// ./src/files/tcfile-form-component.js